module.exports = __webpack_public_path__ + "img/7_dp.462d0c88.png";